import { Dialog, DialogContent } from '@mui/material'
import React from 'react'
import CreatEdit from './CreateEdit'
import  './occupationModal.css';

function RiskFactorCreateModal({productId,handleClose,riskFactorname,apiUrl,setNewValue}) {
  return (
    <Dialog
        fullWidth={true}
        maxWidth={'lg'}
        open={true}
        onClose={handleClose}
      >
       
        <DialogContent className="modalContainer">
          <CreatEdit   setNewValue={setNewValue} apiUrl={apiUrl} riskFactorname={riskFactorname} closeCreateEditForm={handleClose} riskFactorEditDatas={null} editStatus={false} productId ={productId}/>
        </DialogContent>
       
      </Dialog>
  )
}

export default RiskFactorCreateModal